export default {
  label: "Konfigurator",
};
